import waitUniqueCookie from './uniqueCookie';
import waitMultipleCookies from './multipleCookies';

/**
 * Function to wait for a cookie in the browser storage, and if the cookie is found, a callback is runned.
 * @param {String|Array<String>} cookieName name of the cookie to wait for. Can be a string or an array of strings, with the keyvalues.
 * @param {Number} timeout value in ms, total of time to iterate in checkFrecuency for the cookie
 * @param {Number} frecuencyCheck value in ms, frecuency time to check for the cookie before timeout is reached
 * @param {Boolean} callback code to run after find the cookie, if the cookie is reached. Recieve as arg the cookie value.
 * @param {Boolean} returnAnyway return the values found at the end of the timeout, even if the values are not found. Default false.
 */
export default function waitForCookie({
  cookieName,
  timeout,
  frecuencyCheck,
  callback,
  returnAnyway = false,
}) {
  if (typeof cookieName === 'string') {
    waitUniqueCookie(cookieName, timeout, frecuencyCheck, callback);
  }

  if (Array.isArray(cookieName)) {
    waitMultipleCookies(
      cookieName,
      timeout,
      frecuencyCheck,
      returnAnyway,
      callback,
    );
  }
}
